import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import {CustomModule} from "../customs/custom.module";

import {NotificationPanelComponent} from "./notification-panel.component";
import {NotificationPanelRoutingModule} from "./notification-panel-routing.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,    
    NotificationPanelRoutingModule,
      CustomModule
  ],
  declarations: [NotificationPanelComponent]
})
export class NotificationPanelModule {}
